import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { Benutzerprofil } from '../../../stammdaten/mein-profil/mein-profil';
import { FormControl, Validators } from '@angular/forms';
import { KieneBackendApiService } from '../../../../services/backend-api/kiene-backend-api.service';
import { HttpParams } from '@angular/common/http';
import { MessageService } from '../../../../services/message-service/message.service';
import { Router } from '@angular/router';
import { API_BASE_URL_SERVICE } from '../../../../kiene-core.config';
import { Client } from '../../../client/classes/client';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Gruppe } from '../../classes/gruppe';
import { ZeitSlot, ZeitslotBuchung } from './zeitslot';
import { DateUtils } from '../../../../../../../../src/app/dialogs/calendar-week-picker/date-utils';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { KieneUtils } from '../../../../utils/KieneUtils';
import { ZeitslotBuchenBottomSheetComponent } from './zeitslot-buchen-bottom-sheet/zeitslot-buchen-bottom-sheet.component';

@Component({
    selector: 'kiene-zeitslot-buchen-dialog',
    templateUrl: './zeitslot-buchen-dialog.component.html',
    styleUrls: ['./zeitslot-buchen-dialog.component.scss'],
})
export class ZeitslotBuchenDialogComponent implements OnInit, OnDestroy {
    haendlerFavoritenSubscription: Subscription;
    favoritenHaendler: Client[];
    benutzerprofil = new Benutzerprofil();
    standard_schlachthof: any;

    day: ZeitSlot[] = [];

    useHaendlerAsDefault: boolean = true;
    selectedSlot: ZeitSlot;
    slot: ZeitSlot;
    maxCapacity: number = 0;
    countCtrl = new FormControl(undefined, [Validators.required, Validators.min(1)]);
    haendlerCtrl = new FormControl(undefined, [Validators.required]);
    dateCtrl = new FormControl(new Date());

    constructor(
        private api: KieneBackendApiService,
        private messageService: MessageService,
        protected _router: Router,
        @Inject(API_BASE_URL_SERVICE) private apiBaseUrl: string,
        @Inject(MAT_DIALOG_DATA) public gruppe: Gruppe,
        public dialogRef: MatDialogRef<ZeitslotBuchenDialogComponent>,
        private bottomSheet: MatBottomSheet,
    ) {}

    ngOnInit(): void {
        this.maxCapacity = Math.min(this.gruppe?.anzahl_tiere_aktuell, this.slot?.rest_kapazitaet ?? Number.MAX_VALUE);
        this.dateCtrl.valueChanges.subscribe(value => {
            this.changeDay(value);
        });

        this.ladeFavoriten();
    }

    ngOnDestroy(): void {
        this.haendlerFavoritenSubscription?.unsubscribe();
    }

    ladeFavoriten(): void {
        this.haendlerFavoritenSubscription?.unsubscribe();
        this.haendlerFavoritenSubscription = this.api.get(this.apiBaseUrl + 'kunde/read_viehhaendler.php').subscribe({
            next: data => {
                this.favoritenHaendler = data.records;
                this.ladeBenutzerprofil();
            },
            error: (err: any) => {
                this.messageService.errorMessage('Fehler beim Laden aller Händler', err);
            },
        });
    }

    protected buchungAbschliessen(): void {
        if (
            this.useHaendlerAsDefault &&
            !KieneUtils.sameId(this.benutzerprofil.default_haendler_id, this.haendlerCtrl.value?.kunde_id)
        ) {
            this.updateBenutzerprofil();
        }

        console.log('haendler: ', this.haendlerCtrl.value);

        let buchung = new ZeitslotBuchung();
        buchung.tierzahl = this.countCtrl.value;
        buchung.zeitslot_id = this.selectedSlot.zeitslot_id;
        buchung.kunde_id_haendler = this.haendlerCtrl.value?.kunde_id;
        buchung.gruppe_id = this.gruppe?.gruppe_id;
        buchung.geaendert_von = this.benutzerprofil.benutzer_id;

        console.log('Buchung: ', buchung);

        this.api.createGeneric(this.apiBaseUrl + 'zeitslot_buchung/create.php', buchung).subscribe({
            next: (response: ZeitSlot) => {
                this.messageService.infoMessage('Buchung wurde aufgegeben.');
                this.dialogRef.close();
            },
            error: error => {
                if (error.status === 400) {
                    this.messageService.alertMessage(error.error.errortext);
                } else {
                    this.messageService.errorMessage('Es ist ein Fehler aufgetreten: ', error);
                }
            },
        });
    }

    protected selectTimeSlot(slot: ZeitSlot) {
        this.selectedSlot = slot;
        this.maxCapacity = Math.min(this.selectedSlot.rest_kapazitaet, this.gruppe?.anzahl_tiere_gesamt);
    }

    ladeBenutzerprofil() {
        this.api.get(`${this.apiBaseUrl}benutzerprofil/read_one_kundenportal.php`).subscribe({
            next: (response: Benutzerprofil) => {
                this.benutzerprofil = response;
                this.favoritenHaendler.forEach(haendler => {
                    if (KieneUtils.sameId(haendler.kunde_id, this.benutzerprofil.default_haendler_id)) {
                        this.haendlerCtrl.setValue(haendler);
                    }
                });
                if (this.benutzerprofil.default_schlachthof_id) {
                    this.ladeSchlachthofDaten();
                }
            },
            error: err => {
                this.messageService.errorMessage('Profil konnte nicht geladen werden!', err);
            },
        });
    }

    ladeSchlachthofDaten() {
        if (this.benutzerprofil?.default_schlachthof_id) {
            const params = new HttpParams().set('kunde_id', this.benutzerprofil.default_schlachthof_id.toString());
            this.api.get(`${this.apiBaseUrl}schlachthof/read_one.php`, params).subscribe({
                next: (response: any) => {
                    this.standard_schlachthof = response;
                },
                error: err => {
                    this.messageService.errorMessage('Profil konnte nicht geladen werden!', err);
                },
            });
        }
    }

    updateBenutzerprofil() {
        this.benutzerprofil.default_haendler_id = this.haendlerCtrl.value?.client_id;
        this.api
            .updateGeneric(`${this.apiBaseUrl}benutzerprofil/update_kundenportal.php`, this.benutzerprofil)
            .subscribe({
                next: (response: Benutzerprofil) => {
                    this.messageService.infoMessage('Standardhändler erfolgreich gespeichert!');
                    this.benutzerprofil = response;
                },
                error: err => {
                    this.messageService.errorMessage('Fehler! ', err);
                },
            });
    }

    isValid() {
        return (
            this.countCtrl.valid &&
            this.haendlerCtrl.valid &&
            this.selectedSlot?.rest_kapazitaet >= this.countCtrl.value
        );
    }

    changeDay(day: Date) {
        let params = new HttpParams().append('kunde_id_schlachthof', this.benutzerprofil?.default_schlachthof_id);
        day = new Date(day);
        let fromDate = DateUtils.getStartOfDay(day);
        let toDate = DateUtils.plusDays(fromDate, 1);
        params = params.append('zeit_von', fromDate.toISOString());
        params = params.append('zeit_bis', toDate.toISOString());
        this.api.get(this.apiBaseUrl + 'zeitslot/read.php', params).subscribe(res => {
            this.day = res.records;
        });
    }

    openBottomSheet() {
        const ref = this.bottomSheet.open(ZeitslotBuchenBottomSheetComponent, {
            data: { schlachthof_id: this.benutzerprofil.default_schlachthof_id },
        });
        ref.afterDismissed().subscribe(res => {
            if (res) {
                this.selectedSlot = res;
            }
        });
    }

    protected readonly console = console;
}
